// extracted by mini-css-extract-plugin
export default {"container":"Products_container__AMmLB","products":"Products_products__gykMO","menu":"Products_menu__2r7rZ","list":"Products_list__bULZQ","product":"Products_product__9yZ2D"};